import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { generateImage } from "@/faker/generateImage";
import { generateDescription } from "@/faker/generateDescription";
import { createTitle } from "@/functions/createTitle";
import JobsFeed from "@/components/JobsFeed";
import SeoHead from "@/components/SeoHead";
import { Cookies } from "@/components";

export default function JobsPage({ content }) {
  return (
    <>
      {/* <Content items={content} /> */}
      <div style={{marginTop: '120px'}}>
        <SeoHead
            page_name={`Job Search | Xcede Group`}
            canonical_link={`https://www.xcedegroup.com/jobs`}
          />
        <JobsFeed />
      </div>
      
    </>
  );
}